import { useState } from "react";
import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import DataTable from "react-data-table-component";
import Modal from "../../molecules/Modal";
import NoData from "../../molecules/NoData";
import ModalConfirm from "../../molecules/ModalConfirm";
import ActionsTables from "../../molecules/ActionsTables";
import UsuariosCrudEdit from "./UsuariosCrudEdit";
import useModal from "../../../hooks/useModal";
import { DELETE_USER } from "../../../api/apiUsers";

const UsuariosCrudTable = ({ data, refetch, loading }) => {
    const [loadingDelete, setLoadingDelete] = useState();
    const [selected, setSelected] = useState(null);
    const { open, isOpen, close } = useModal();
    const { open: openDelete, isOpen: isOpenDelete, close: closeDelete } = useModal();

    const handleOpenEdit = (inmueble) => {
        open();
        setSelected(inmueble);
    };

    const handleOpenDelete = (inmueble) => {
        openDelete();
        setSelected(inmueble);
    };

    const handleClose = () => {
        close();
        closeDelete();
        setSelected();
    };

    const handleDelete = async () => {
        if (!selected) return;

        setLoadingDelete(true);
        try {
            await toast.promise(
                DELETE_USER(selected.id),
                {
                    pending: 'Eliminando usuario...',
                    success: 'Usuario eliminado correctamente.',
                    error: 'No se pudo eliminar el usuario.'
                }
            );
            refetch();
            handleClose();
        } catch (error) {
            console.error("Error al eliminar el usuario:", error);
        } finally {
            setLoadingDelete(false);
        }
    };

    const columns = [
        { name: "Nombre de usuario", selector: row => row.name, },
        { name: "Correo", selector: row => row.email, },
        { name: "Telefono", selector: row => row.cellphone, },
        {
            name: "Acciones",
            cell: (row) => ( <ActionsTables row={row} handleOpenEdit={handleOpenEdit} handleOpenDelete={handleOpenDelete} /> ),
        },
    ];

    return(
        <>
            <DataTable
                data={data}
                progressPending={loading}
                columns={columns}
                progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                noDataComponent={<NoData />}
                pagination
            />
            {isOpen && selected !== null &&
                <Modal title="Editar usuario" onClose={handleClose}>
                    <UsuariosCrudEdit onClose={handleClose} refetch={refetch} user={selected} />
                </Modal>
            }
            {isOpenDelete && selected !== null &&
                <ModalConfirm loading={loadingDelete} onConfirm={handleDelete} onClose={handleClose} eliminacion />
            }
        </>
    );
};

export default UsuariosCrudTable;